<template>
    <div class="c-client-detail">
        <SphereNavigation color="blue" selected="client-search" :intro="false" />

        <div class="inner-content">
            <h1>{{$t('client_detail.title')}}</h1>

            <div class="action-content">
                <div class="qr-code">
                    <div class="qr-code--wrapper">
                        <video id="qr-video"></video>
                        <!-- <button @click.prevent="testQrScan">test qr</button> -->
                    </div>
                    <button class="btn-basic bordered btn-search" type="button" @click.prevent="hideQR">
                        {{$t('generic.cancel')}}
                    </button>
                </div>

            </div>

            <div v-if="serverError" class="result-error">
                {{$t('generic.server_error')}}
            </div>
        </div>
    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import {apiStore} from "@/stores/api";
import QrScanner from "qr-scanner";

export default {
    name : "ClienSearchQR",
    components : {
        SphereNavigation
    },

    data() {
        return {
            qrScanner : null,
            codeFound : false,
            loading : false,
            serverError: false
        };
    },

    created() {
        this.$nextTick(() => {
            const videoEl = document.getElementById("qr-video");
            this.qrScanner = new QrScanner(videoEl, this.onCodeFound);
            this.qrScanner.start();
        });
    },

    unmounted : function() {
        if (this.qrScanner !== null) {
            this.qrScanner.destroy();
        }
    },

    methods: {
        testQrScan() {
            const code = "68E40E08-B25A-11EB-9164-84C5A69C1976";
            // const code = '3CC3F5B6-4BF3-11E9-994B-48D224847B01'; //ergosleep_id ikke
            this.onCodeFound(code);
        },

        onCodeFound(result) {
            if (!this.codeFound) {
                this.codeFound = true;

                this.getErgosleepUserData(result);
            }
        },

        hideQR() {
            this.$router.replace({name : "client-search"});
        },

        async getErgosleepUserData(code) {
            this.loading = true;
            this.serverError = false;

            try {
                const result = await apiStore().getErgosleepUserById(code);
                if (result.client !== null) {
                    const clients = [result.client];
                    apiStore().clientSearchResult = clients;
                    this.$router.push({name : "client-search-result"});
                } else {
                    this.clients = [];
                }

                this.qrScanner.stop();
                this.qrScanner.destroy();

            } catch (error) {
                console.log("getErgosleepUserData", error);
                this.codeFound = false;
                this.serverError = true;

            }

            this.loading = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-client-detail {
        height : 100%;

        .inner-content {
            padding-left: 45%;
            padding-top : 3%;
        }

        .action-btns {
            .btn-basic {
                margin-right : 1rem;
            }

            @for $i from 1 through 5 {
                & > *:nth-child(#{$i}) {
                    @include slideIntroAnimation(basicSlideIntro, 450ms, #{250ms + $i * 250ms});
                }
            }
        }

        // .action-content {
        //     margin-top: 2rem;
        // }

        .qr-code {
            position: relative;
        }

        .qr-code--wrapper {
            margin-bottom : 2rem;
        }

        video {
            margin-top : 1rem;
            width : 75%;
        }

        .btn-search {
            display:block;
        }

        .result-error {
            color : $color-red;
            font-size : 1.2rem;
            margin-top : 1.2rem;
        }

        .search-form {
            @include slideIntroAnimation(basicSlideIntro, 450ms, 50ms);

            .inputfield {
                width : 49%;
                display: block;
            }

            .btns {
                display: flex;
                .btn-basic {
                    margin-right : 2rem;
                }
            }

            &--row {
                display: flex;
                justify-content: space-between;
            }
        }

        .btn-reset {
            @include slideIntroAnimation(basicSlideIntro, 450ms, 50ms);
        }

        .no-results {
            margin-bottom: 2rem;
        }

        .list--item {
            .email {
                color : #999999;
            }

            .left {
                margin-left : 1rem;
            }
            .right {
                margin-right : 1rem;
            }
        }

        .list {
            height : 55vh;
        }
    }
</style>